<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      prontuario: null,
    };
  },
  methods: {
    getProntuario() {
      this.prontuario = null;

      api
        .get('telemedicina/prontuario')
        .then((response) => {
          if (response.data.status == 'success') {
            this.prontuario = response.data.list;
          }
        })
    },
  },
  mounted() {
    this.getProntuario();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meu Prontuário</h3>
        <p>Acesse suas prescrições médicas.</p>
      </div>
    </div>
    <div v-if="!prontuario" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="prontuario && prontuario.length == 0">
      <div class="card">
        <div class="card-body text-center">
          Nenhum histórico encontrado.
        </div>
      </div>
    </div>

    <div v-else>
      <a class="d-block text-dark mb-2" target="_blank" :href="row.prescription.url" v-for="(row, index) in prontuario" :key="index">
        <div class="card card-icon mb-0">
          <div class="card-body d-flex align-items-center">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                <path
                  d="M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072 4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072 4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892-4.242-4.244 2.892-2.891z">
                </path>
              </svg>
            </div>
            <div class="ml-3 w-75 pt-1">
              <p v-if="row.type == 'call'" class="mb-1 text-dark"><strong>PLANTÃO MÉDICO 24H</strong></p>
              <p v-else class="mb-1 text-dark"><strong>CONSULTA</strong></p>
              <h5 class="m-0 text-dark font-size-16"><strong>{{ row.prescription.date }}</strong></h5>
              <p class="m-0 text-dark font-size-12">{{ row.professional.name }}</p>
            </div>
            <div class="ml-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                <path d="m12 16 4-5h-3V4h-2v7H8z"></path>
                <path d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"></path>
              </svg>
            </div>
          </div>
        </div>
      </a>
    </div>
  </Layout>
</template>